import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useDetalhesProposta = defineStore("detalhesProposta", () => {
  const activeStep = ref(0);
  const operationStatusId = ref<number | null>(null);

  const stepNames: Record<number, string> = {
    0: "Simulação",
    1: "Detalhes da Proposta",
    2: "Documentação",
    3: "Análise da Documentação",
    4: "Contrato",
    5: "Análise Contrato",
    6: "Faturamento",
    7: "Análise de Faturamento",
    8: "Implantação",
    9: "Análise da Implantação",
    10: "Monitoramento",
  };

  const currentStepName = computed(() => {
    const baseName = stepNames[activeStep.value] || "Detalhes da Proposta";

    // Status de reprovação
    if (operationStatusId.value === 2) {
      // SIMULACAO_REPROVADA
      return "Proposta Reprovada";
    }
    if (
      operationStatusId.value === 7 ||
      operationStatusId.value === 10 ||
      operationStatusId.value === 11
    ) {
      return "Documentação Reprovada";
    }
    if (operationStatusId.value === 21) {
      // NOTA_FISCAL_REJEITADA
      return "Faturamento Reprovado";
    }
    if (operationStatusId.value === 28) {
      // INSTALACAO_REJEITADA
      return "Implantação Reprovada";
    }

    return baseName;
  });

  const setActiveStep = (step: number) => {
    activeStep.value = step;
  };

  const setOperationStatusId = (statusId: number | null) => {
    operationStatusId.value = statusId;
  };

  const resetStep = () => {
    activeStep.value = 0;
  };

  return {
    activeStep,
    operationStatusId,
    currentStepName,
    stepNames,
    setActiveStep,
    setOperationStatusId,
    resetStep,
  };
});
